import { render, staticRenderFns } from "./PracticeClosureTab.vue?vue&type=template&id=73324d6a&scoped=true"
import script from "./PracticeClosureTab.vue?vue&type=script&lang=js"
export * from "./PracticeClosureTab.vue?vue&type=script&lang=js"
import style0 from "./PracticeClosureTab.vue?vue&type=style&index=0&id=73324d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73324d6a",
  null
  
)

export default component.exports